import "./App.css";
import "./styles/loader.css";
import "react-toastify/dist/ReactToastify.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-material.css";
import * as AgGrid from "ag-grid-enterprise";
import { GridChartsModule } from "@ag-grid-enterprise/charts";
import { QueryClientProvider } from "react-query";
import { Dialog, ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import Router from "./routes";
import ScrollToTop from "./components/shared/ScrollToTop";
import { muiTheme } from "./theme/mui";
import { queryClient } from "./queries";
import AlertDialog from "./components/shared/AlertDialog";
import { useDialogStore } from "./store/alertDialog";
import { useAuthStore, useAuthorizationStore } from "./store";
import HandleHissaRedirect from "./components/shared/HandleHissaRedirect";
import DialogContainer from "./components/DialogContainer";
import { amplitudeInit, handleClickForTracking } from "./amplitudeAnalytics";
import { usePermissionStore } from "./store/permissionStore";
import { WarningModal } from "./components/utils";

const agGridLicenseKey = process.env.REACT_APP_AG_LICENSE_KEY || "";
AgGrid.LicenseManager.setLicenseKey(agGridLicenseKey);

function App() {
  amplitudeInit();
  useEffect(() => {
    queryClient.prefetchQuery("vestingTemplates");
  });
  useAuthStore();
  useAuthorizationStore();
  usePermissionStore();

  const channelRef = useRef<BroadcastChannel | undefined>();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const tabId = sessionStorage.getItem("tabId") || generateRandomString(8);
    sessionStorage.setItem("tabId", tabId);
    const channel = new BroadcastChannel("single-tab-check");
    channelRef.current = channel;
    let isFirstTab = true;
    channel.onmessage = (event) => {
      const { type, senderId } = event.data;
      if (senderId === tabId) {
        return;
      }
      if (type === "anyone-there?") {
        channel.postMessage({ type: "i-am-here", senderId: tabId });
      }
      if (type === "i-am-here") {
        isFirstTab = false;
        setShowModal(true);
      }
    };
    channel.postMessage({ type: "anyone-there?", senderId: tabId });
    const timer = setTimeout(() => {
      if (!isFirstTab) {
        setShowModal(true);
      }
    }, 500);
    return () => {
      clearTimeout(timer);
      channel.close();
    };
  }, []);
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ScrollToTop />
        <HandleHissaRedirect />
        <ThemeProvider theme={muiTheme}>
          <div
            onClick={(e) => {
              handleClickForTracking(e);
            }}
          >
            {showModal ? <WarningModal open={showModal} /> : <Router />}
          </div>
          <ToastContainer position="bottom-right" autoClose={2000} />
          <AlertDialog {...useDialogStore().dialog} />
          <DialogContainer />
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
}

function generateRandomString(length: number) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
}

export default App;
